export enum Patch {
  UpdateCompanyLocations = 'UpdateCompanyLocations',
  RejectMatchByCompany = 'RejectMatchByCompany',
  ContactMatch = 'ContactMatch',
  InterviewMatch = 'InterviewMatch',
  HireMatch = 'HireMatch',
  OnHoldMatch = 'OnHoldMatch',
  ReAcceptMatchByCompany = 'ReAcceptMatchByCompany',
  RejectMatchByApplicant = 'RejectMatchByApplicant',
  AcceptMatchByApplicant = 'AcceptMatchByApplicant',
  UpdateCompanyMatchNotes = 'UpdateCompanyMatchNotes',
  ActivateJobPosting = 'ActivateJobPosting',
  UpdateCompanyBenefits = 'UpdateCompanyBenefits',
  UpdateCompanyDepartment = 'UpdateCompanyDepartment',
  UpdateMatchComment = 'UpdateMatchComment',
  UpdateScreeningApplicant = 'UpdateScreeningApplicant',
  SaveChatBasedTalentSurveyResult = 'saveChatBasedTalentSurveyResult',
  UpdateQuestionnaire = 'UpdateQuestionnaire',
  CompleteCompanySurvey = 'CompleteCompanySurvey',
  UpdateApplicantProfile = 'UpdateApplicantProfile',
  UpdateUserTwoFactorAuthentication = 'UpdateUserTwoFactorAuthentication',
  UpdateDepartmentTargetProfile = 'UpdateDepartmentTargetProfile',
  UpdateDepartmentTargetProfileSkill = 'UpdateDepartmentTargetProfileSkill',
}
